// import groupBy from 'lodash/groupBy';
// import isEmpty from 'lodash/isEmpty';
import staticUserRoles from '../../static/user_roles.json';
// import availableFeatures from '../../static/features.json';
import staticServices from 'static/services.json';
import { ROLES } from '../constants';
// import { ROLES } from '../constants';
// import isEmpty from 'lodash/isEmpty';
import uniqBy from 'lodash/uniqBy';

/**
 * Fina a role from the user_roles.json
 * @param {string}roleId - a unique string representing a role
 * @returns {*} - a user object containing details need for business logic
 */
export const findARole = roleId => {
  return staticUserRoles.find(role => role.id === roleId);
};

// export const hasSubscription = ({ subscribedProducts, serviceTypes }) => {
//   const product = subscribedProducts.some(item =>
//     canAccessService({
//       allowableServices: item.allowableServices,
//       subscribedServices: serviceTypes,
//     }),
//   );
//   return product;
// };

// export const hasSecurityService = ({
//   serviceTypes,
//   subscribedCompanyServices,
// }) => {
//   return subscribedCompanyServices.includes(serviceTypes);
// };
/**
 * Checks if the feature is in the list of features that the company has in its subscription
 * @param {[]}features - provided by the company object
 * @param {string}feature - Unique string identifier
 * @returns {boolean} - true if the feature is in the list
 */
export const hasFeature = ({ subscribedFeatures, feature }) => {
  return subscribedFeatures?.includes(feature);
};
/**
 * Checks if the service is in the list of services that the company has in its subscription
 * @param {[]}services - provided by the company object
 * @param {string}service - Unique string identifier
 * @returns {boolean} - true if the feature is in the list
 */
export const hasService = ({ services = [], service }) => {
  if (!service) return false;
  let hasService = false;
  if (typeof service === 'string') {
    hasService = services.includes(service);
  } else {
    // of type array like in emergency or transport where there are more than one types
    hasService = service.some(s => services.includes(s));
  }
  return hasService;
};

/**
 * List of dynamic services in the company object
 * @param {[]}services - provided by the company object
 * @returns {Array} -   A map of category and its allowableServices
 * [{category:'', allowableServices: [{id:'', name:'', icon: ''},{id:'', name:'', icon: ''}....]}]
 */
export const getServiceByCategory = ({ services }) => {
  if (!services || services.length === 0) return []; //there are no services so just return.
  return staticServices.reduce((catMap, staticServiceObject) => {
    if (services.includes(staticServiceObject.id)) {
      const [cat] = catMap.filter(
        f => f.category === staticServiceObject.category,
      );
      const allowableService = {
        id: staticServiceObject.id,
        name: staticServiceObject.name,
        icon: staticServiceObject.icon,
      };
      if (cat) {
        cat.allowableServices.push(allowableService);
      } else {
        catMap.push({
          category: staticServiceObject.category,
          allowableServices: [allowableService],
        });
      }
    }
    return catMap;
  }, []);
};

//   const service = services.filter(item => serviceTypes.includes(item));
//   return product && service;
// };

export const categoryFieldName = category => category.toLowerCase();

// export const getAllowableProducts = subscriptions => {
//   const s = (subscriptions || []).map(
//     ({ displayName, willChangeToPlan, ...subscription }) => {
//       const prod = products.find(item => item.id === subscription.platform);

//       const allowableServices = prod.availableServices
//         .filter(item => subscription.allowableServices.indexOf(item.id) > -1)
//         .sort((a, b) => a.name.localeCompare(b.name));

//       const allowableRoles = staticUserRoles.filter(user =>
//         subscription.allowableRoles.includes(user.id),
//       );

//       const getPendingDowngradePlan = () => {
//         if (!willChangeToPlan) return null;
//         const [{ planId, ...transform }] = getAllowableProducts([
//           willChangeToPlan,
//         ]);

//         return {
//           newPlanId: planId,
//           willUpdateAt: subscription.willUpdateAt,
//           ...transform,
//         };
//       };
//       return {
//         ...subscription,
//         willChangeToPlan: getPendingDowngradePlan(),
//         allowableRoles,
//         allowableServices,
//         productSuite: subscription.platform,
//         productSuiteLabel: subscription.name,
//         productName: displayName,
//         features: isEmpty(subscription.features) ? [] : subscription.features,
//       };
//     },
//   );
//   return [...s];
// };

// getallowableRoleServicesMap
// [{role: {id: ,name}, allowableService: [{id:'',name:'', icon: ''},{}]}]

// export const productHasFeature = ({ features, feature }) => {
//   return features.includes(feature);
// };
/**
 * Helper method to check if the subscribed services contains the services required. Used to show/hide pages and components.
 * @param {[]}allowableServices - a list of services you want to check for
 * @param {[]}subscribedServices - the list of services from the Security Company Object that the user's company is subscribed to.
 * @returns {boolean} - true if it contains any of the services.
 */
export const canAccessService = ({ allowableServices, subscribedServices }) => {
  return allowableServices.some(item => {
    return subscribedServices.includes(item.id);
  });
};

// export const getAllowableRolesByProductId = (subscribedProducts, productId) => {
//   if (subscribedProducts.length === 0) return [];
//   const productDetails = subscribedProducts.find(
//     item => item.productSuite === productId,
//   );

//   return productDetails ? productDetails.allowableRoles : [];
// };

export const getAllowableRolesBySubscription = (
  subscribedProducts,
  specificRoles = [],
) => {
  if (subscribedProducts.length === 0) return [];
  const allowedRoles = subscribedProducts.reduce((arr, { allowableRoles }) => {
    const rolesCanAdd =
      specificRoles.length > 0
        ? allowableRoles.filter(role => {
            return specificRoles.includes(role.id);
          })
        : allowableRoles;
    return arr.concat(rolesCanAdd);
  }, []);

  const uniqueValues = Array.from(new Set(allowedRoles.map(a => a.id)))
    .map(id => {
      const found = allowedRoles.find(a => a.id === id);
      return {
        id: found.id,
        name: found.name,
        allowableServices: found.allowableServices,
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));

  return uniqueValues;
};

export const getServiceByRole = (availableServices, allowableServices) => {
  return availableServices.filter(
    item => allowableServices.indexOf(item.id) > -1,
  );
};
export const getAllowableServicesByRole = ({
  role,
  subRole = false,
  multiRoleDisplay,
  serviceRoleMap,
}) => {
  if (!role) {
    return [];
  } else {
    // find a selected role from drop down
    const getAllowedServicesBasedOnRole = serviceRoleMap.find(
      f => f.role.id === role,
    );

    if (!getAllowedServicesBasedOnRole) {
      return [];
    }

    const allowableServiceRole = serviceRoleMap?.reduce((arr, elem) => {
      const roleServices = [];
      // get the list of services based on the company subscription product
      const servicesCanProvide =
        getAllowedServicesBasedOnRole.allowableServices;

      roleServices.push(...servicesCanProvide);

      if (getAllowedServicesBasedOnRole.multiRole) {
        getAllowedServicesBasedOnRole.multiRole.forEach(item => {
          const isMultiRoleSelected = multiRoleDisplay
            ? multiRoleDisplay[item] || false
            : true;

          const r = findARole(item);
          const hasAccess = elem.allowableServices.some(i =>
            r.allowableServices.includes(i.id),
          );

          if (hasAccess && isMultiRoleSelected) {
            // get multiRole services
            const [multiRoleServices] = serviceRoleMap.filter(
              f => f.role.id === item,
            );
            roleServices.push(...multiRoleServices.allowableServices);
          }
        });
      }

      const u = {
        productSuite: elem.platform,
        name: 'Services',
        allowableServices: roleServices.sort((a, b) =>
          a.name.localeCompare(b.name),
        ),
        planId: elem.planId,
        productName: elem.productName,
      };

      const sorted = roleServices.sort((a, b) => a.name.localeCompare(b.name));

      return roleServices.length > 0 ? arr.concat(subRole ? sorted : u) : arr;
    }, []);
    // curates all the allowableServices to a single array
    const combinedServicesByRole = allowableServiceRole.reduce((prev, curr) => {
      const { allowableServices } = curr;

      const [found] = prev.filter(f => f.name === 'Services');
      if (found) {
        found.allowableServices.push(...allowableServices);
      } else {
        prev.push({
          allowableServices: [...allowableServices],
          name: 'Services',
        });
      }
      return prev;
    }, []);
    // remove any duplicates
    const uniqueServices = [
      ...new Set(
        combinedServicesByRole.map(item => ({
          ...item,
          allowableServices: uniqBy(item.allowableServices, 'id'),
        })),
      ),
    ];
    return uniqueServices;
  }
};
/**
 * Get the union of the role services with the company's allowed services
 * @param {string}role //the id of the role
 * @param {[]}services //The services the company is subscribed to
 * @returns {[]} // the services for the role.
 */
export const getAllowableServicesForRole = ({ role, services }) => {
  //get the role object from the staticUserRoles
  const roleObject = staticUserRoles.filter(item => {
    return item.id === role;
  });
  if (!roleObject) {
    return [];
  }
  // union of 2 arrays
  if (!services || services.length < 1) return [];
  const filteredServices = services.filter(item => {
    let contains = false;
    roleObject.services.forEach(i => {
      if (i.id === item.id) {
        contains = true;
      }
    });
    return contains;
  });
  return filteredServices;
};

export const getSubscribedServicesByRole = ({
  role,
  serviceRoleMap,
  multiRoleDisplay,
}) => {
  if (!role) return [];
  const s = getAllowableServicesByRole({
    role,
    multiRoleDisplay,
    serviceRoleMap,
  });

  return s;
};
/**
 * check if the user can be a Responder...
 * @returns {*} all roles that can be multi-role.
 */
export const getMultiRoleResponder = () =>
  staticUserRoles
    .filter(item => {
      return item.multiRole && item.multiRole.includes(ROLES.RESPONDER.id);
    })
    .map(item => item.id);
// export const getSubscriptionByType = ({ subscriptions, type }) => {
//   return subscriptions.filter(item => item.type === type);
// };

// export const getServicesByProductSuite = ({ products }) => {
//   const groupByProduct = groupBy(products, 'productSuite');
//   const services = Object.entries(groupByProduct).map(([key, platform]) => {
//     const allowableServices = platform.reduce((acc, current) => {
//       return [...new Set(acc.concat(current.allowableServices))];
//     }, []);
//     return { productSuite: key, allowableServices };
//   });

//   return services.sort((a, b) => a.productSuite.localeCompare(b.productSuite));
// };
/**
 * This function helps to programmatically hide the column in aggrid depending on a feature
 * @param {[]} features // products that security company is subscribed to
 * @param {String} feature // feature to check if enabled or not
 * @param {String} field // field to hide
 * @param {Boolean} areDepartmentsAvailable // a check if the departments are available or not
 * @returns {Object}  { field: hiddenField, hide: true||false}
 */
export const getHiddenFieldIfNotEnabled = ({
  subscribedFeatures,
  feature,
  field,
  areDepartmentsAvailable,
}) => {
  const isFeatureEnabled = hasFeature({ subscribedFeatures, feature });
  // is feature is enabled but there are not departments then hide
  if (isFeatureEnabled && areDepartmentsAvailable) {
    return { field, hide: false };
  }

  return { field, hide: true };
};

// Only accepts filterValue to find of type bool
export const getHiddenFieldBasedOnFilters = ({
  filters = {},
  filterValueToFind = '',
  field = '',
}) => {
  // In future, This may need to be rewritten to incorporate other datatype such as string, array, enums etc.
  // find if the filterValueToFind key exists in filters
  const isKeyAvailable = Object.prototype.hasOwnProperty.call(
    filters,
    filterValueToFind,
  );
  return { field, hide: !(isKeyAvailable && filters[filterValueToFind]) };
};

export const getServiceTaskCategories = ({ services }) => {
  if (!services || services.length === 0) return []; //there are no services so just return.
  return staticServices.reduce((catMap, staticServiceObject) => {
    if (
      services.includes(staticServiceObject.id) &&
      staticServiceObject.isTask
    ) {
      const allowableService = {
        id: staticServiceObject.id,
        name: staticServiceObject.name,
        icon: staticServiceObject.icon,
      };
      catMap.push(allowableService);
    }
    return catMap;
  }, []);
};

// check if the user has the required service and the service object hasTask true
export const checkIfServicesHasIsTask = ({ services = [] } = {}) => {
  if (!services) return false;
  return staticServices
    .filter(f => services.includes(f.id))
    .some(s => s.isTask);
};
